import { FC, memo } from 'react';

import { useTranslation } from '@/i18n';
import { digitsSeparatorAllowNullAndUndefined } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import styles from './index.module.scss';

export type Props = {
  minNumericValue?: string;
  maxNumericValue?: string;
};

const cx = classNames.bind(styles);

export const NumericRangeSummary: FC<Props> = memo(
  ({ minNumericValue, maxNumericValue }: Props) => {
    const { t } = useTranslation();

    if (minNumericValue === undefined && maxNumericValue === undefined) {
      return (
        <div className={cx(styles['range_unset_text'])}>
          {t('transaction_items.drawer.component_type.range_unset')}
        </div>
      );
    }

    return (
      <div className={cx(styles['range_summary_container'])}>
        <span>
          {digitsSeparatorAllowNullAndUndefined(minNumericValue ?? '')}
        </span>
        <span>~</span>
        <span>
          {digitsSeparatorAllowNullAndUndefined(maxNumericValue ?? '')}
        </span>
      </div>
    );
  }
);

NumericRangeSummary.displayName = 'NumericRangeSummary';
